import React, { useEffect, useState } from 'react';
import ToastManager from '../../../Components/ToastManager';
import { NetworkManager } from '../../../Components/NetworkManager';
import { CommonUtil } from '../../../utils/CommonUtil';
import InspectionDetails from './InspectionDetails';
import InspectedDetails from './InspectedDetails';

interface Process {
  processId: number;
  processName: string;
  taskDetails: any[]; 
}

const InspectionDocDetails = () => {  
  const selectedDocTypeId = localStorage.getItem("selectedDocTypeId");
  const saasOrgId = CommonUtil.getSaasOrgId();
  const [data, setData] = useState<{processDetails?: Process[]} | null>(null);
  const [selectedProcessId, setSelectedProcessId] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);


  const onLoginError = (err: any) => {
    console.log(err);
  };
  
  useEffect(() => {
    getDocInspection();
  }, []);

  const getDocInspection = () => {
    setLoading(true);
    const orgUrl = `api/dashboard/inspection-event-details/?orgId=${saasOrgId}&docId=${CommonUtil.getInterchangeDocumentId()}${selectedDocTypeId ? "&dependentDpcTypeId="+selectedDocTypeId : ""}`;
    NetworkManager.sendJsonRequest(orgUrl, "", "", "GET", true, onDocInspection, onLoginError);
  };
  
  const onDocInspection = (dataObj: any) => {
    try {
      const restData = JSON.parse(dataObj);
      if (restData && !restData.errorMessage) {
        const data = restData?.map((item: any)=>{
            return {
              ...item,
              multiReleaseId: item?.multiReleaseId ? item?.multiReleaseId : 0
            };
        });
        
        setData(data);
        if (data.processDetails?.length) {
          setSelectedProcessId(data.processDetails[0].processId);
        }
      } else {
        ToastManager.showToast(restData?.errorMessage || "Unknown error", "Error");
      }
    } catch (e) {
      console.error("Parsing error:", e);
      ToastManager.showToast("Failed to parse response", "Error");
    } finally {
      setLoading(false);
    }
  }

  const selectedProcess = data?.processDetails?.find(
    p => p.processId === selectedProcessId
  );

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;
  }

  if (!data) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>No process data available</div>;
  }
  return (
    <>
      {/* <InspectionDetails data={data} getDocInspection={getDocInspection} /> */}
      <InspectedDetails data={data} getDocInspection={getDocInspection} />
    </>
  )
};

export default InspectionDocDetails;